// Başvuru aksiyon görünürlüğü — TEK KAYNAK.
//
// Aynı aksiyon kümesi iki yerde çizilir: liste satır menüsü (AtsApplicationsPage)
// ve başvuru detayının Genel Bakış şeridi (tab-pages/ApplicationOverviewTab).
// Kurallar iki dosyada ayrı ayrı yazılsaydı ilk değişiklikte sessizce ayrışırlardı
// (ats-requisitions/requisitionActions.js ile aynı gerekçe).
//
// Kapılar backend'in KODUNDAN doğrulandı (yorumlarından değil):
//   • AtsApplicationController.MoveToStage / ChangeStatus / BulkStatus →
//     `IsAdmin() || HasPermission("AT.Write")` ile `isPrivileged` geçer,
//     AtsApplicationDataAccess her ikisinde de `if (!isPrivileged) 403
//     ats.application.notAuthorizedForAction` der. İşe alım yöneticisi (HM)
//     SALT-İZLER — süreç aksiyonu yoktur.
//   • AtsApplicationResponse.CanManage = fullVisibility, yani bugün tam olarak
//     AT.Write/admin. Bu yüzden `resolveCanManage` = canWrite('AT') || row.canManage
//     (sunucunun kendi bayrağı; ikisi bugün aynı şeyi söyler).
//   • Aşama taşıma ayrıca DURUMA bakar: `on_hold` → 409 cannotMoveOnHold,
//     terminal → 409 cannotMoveTerminal. Yani YALNIZ `active`.
//   • Teklif ve silme AT.Write'tır (CanManage bayrağı DEĞİL).

// Duruma göre izinli durum geçişleri — AtsApplicationDataAccess.ResolveTransition
// ile birebir. `offer` KASITLI yok: teklif bir durum çevirmesi değil, gerçek bir
// AtsOffer kaydıdır (OfferCreateDialog).
// ⚠ ResolveTransition'da ("offered","reject") de var; arayüz onu SUNMAZ, çünkü
// teklif reddi teklif akışından (AtsOffer) geçer — buradaki eksiklik kasıtlıdır.
export const STATUS_TRANSITIONS = {
  active: [
    { action: 'hold', labelKey: 'ats.application.action.hold' },
    { action: 'disqualify', labelKey: 'ats.application.action.disqualify', requiresReason: true },
    { action: 'withdraw', labelKey: 'ats.application.action.withdraw' },
  ],
  on_hold: [
    { action: 'resume', labelKey: 'ats.application.action.resume' },
    { action: 'disqualify', labelKey: 'ats.application.action.disqualify', requiresReason: true },
    { action: 'withdraw', labelKey: 'ats.application.action.withdraw' },
  ],
  offered: [
    { action: 'withdraw', labelKey: 'ats.application.action.withdraw' },
  ],
  withdrawn: [],
  disqualified: [],
  accepted: [],
  rejected: [],
};

// Silinebilir durumlar — AtsApplicationDataAccess.Delete (BP-15) ile aynı küme.
// Canlı süreçteki satır silinirse Employee/koltuk kaskadı öksüz kalır; BE 409
// `ats.application.cannotDeleteStatus` döner.
export const DELETABLE_STATUSES = ['withdrawn', 'disqualified', 'rejected'];

// "Teklif Yap" — `offered` satırda da açıktır: canlı teklifi geri çekilmiş/reddedilmiş
// olabilir; hâlâ canlıysa BE `ats.offer.liveAlreadyExists` ile reddeder.
export const OFFERABLE_STATUSES = ['active', 'on_hold', 'offered'];

// Yalnız `active` başvuru aşama değiştirebilir.
export const STAGE_MOVABLE_STATUSES = ['active'];

// AT.Write (canWrite('AT')) VEYA sunucunun satır bayrağı. İkisi bugün aynı kapıdır;
// bayrak, kapı ileride gevşerse arayüzün sunucuyu takip etmesi için okunur.
export const resolveCanManage = (application, { writable }) =>
  !!writable || !!(application && application.canManage);

export const canMoveStage = (application, { canManage }) =>
  !!canManage && !!application && STAGE_MOVABLE_STATUSES.includes(application.status);

// Durum aksiyonları (Devam Et / Beklemeye Al / Diskalifiye Et / Aday Vazgeçti).
export const visibleTransitions = (application, { canManage }) => {
  if (!application || !canManage) return [];
  return STATUS_TRANSITIONS[application.status] || [];
};

export const canOffer = (application, { writable }) =>
  !!writable && !!application && OFFERABLE_STATUSES.includes(application.status);

export const canDelete = (application, { writable }) =>
  !!writable && !!application && DELETABLE_STATUSES.includes(application.status);

// Mülakat planlama İK'da (AT.Write) veya ilana atanmış koordinatörde
// (AtsApplicationResponse.CanSchedule) — CanManage'den AYRIK kapı.
// Kapanmış başvuruya mülakat planlanmaz.
const SCHEDULABLE_BLOCKED_STATUSES = ['rejected', 'accepted', 'withdrawn', 'disqualified'];

export const canScheduleInterview = (application, { writable }) => {
  if (!application) return false;
  if (!writable && !application.canSchedule) return false;
  return !SCHEDULABLE_BLOCKED_STATUSES.includes(application.status);
};

// Bir başvuruda "açık" (henüz sonuçlanmamış) mülakat var mı — ikinci mülakatın
// yanlışlıkla planlanmasını önleyen uyarının kaynağı. `rescheduled` satır ertelenmiş
// olanın KENDİSİdir (yerine yeni satır açılır), açık sayılmaz.
export const OPEN_INTERVIEW_STATUSES = ['scheduled'];

export const openInterviewsOf = (interviews) =>
  (interviews || []).filter((iv) => OPEN_INTERVIEW_STATUSES.includes(iv && iv.status));
